module.exports = __webpack_public_path__ + "static/media/slide5.8b997f4e.jpg";